import { jsx as _jsx } from "react/jsx-runtime";
// icon:bxs-bank | Boxicons https://boxicons.com/ | Atisa
export const BxsBank = (props) => {
    return (_jsx("svg", { viewBox: "0 0 24 24", fill: "currentColor", height: "1em", width: "1em", ...props, children: _jsx("path", { d: "M2 8v4.001h1V18H2v3h16l3 .001V21h1v-3h-1v-5.999h1V8L12 2 2 8zm4 10v-5.999h2V18H6zm5 0v-5.999h2V18h-2zm7 0h-2v-5.999h2V18zM14 8a2 2 0 11-4.001-.001A2 2 0 0114 8z" }) }));
};
